import {
  AlertDialogBody as AlertDialogBodyPrimitive,
  type ModalBodyProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function AlertDialogBody(props: ModalBodyProps): ReactNode {
  return <AlertDialogBodyPrimitive px="6" py="4" {...props} />;
}
